import React from 'react';
import { PlaceholderLoader, Table, Modal } from '../index.js';
const StatusModal = (props) => {
    const { rkiStatus } = props;
    return (React.createElement(Modal, { header: "Status hos Experian vedr. RKI-registrering", onToggle: props.toggleStatusModal, maxWidth: "600px" }, rkiStatus ? (React.createElement(Table, { zebra: true }, rkiStatus &&
        rkiStatus.Results &&
        rkiStatus.Results.Status &&
        rkiStatus.Results.Status[0] &&
        Object.entries(rkiStatus.Results.Status[0]).map((entry) => (React.createElement("tr", null,
            React.createElement("td", null, entry[0]),
            React.createElement("td", null,
                React.createElement("b", null, 
                // @ts-ignore
                entry[1] && entry[1].length
                    ? // @ts-ignore
                        entry[1].join()
                    : entry[1]))))))) : (React.createElement(PlaceholderLoader, null))));
};
export default StatusModal;
//# sourceMappingURL=StatusModal.js.map